import { keyBy } from 'es-toolkit';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Trailer } from '@paragon/contract-library';

interface TrailersState {
  status: 'loading' | 'loaded' | 'catastrophicallyFailed';

  trailers: Record<string, Trailer>;
}

const initialState: TrailersState = {
  status: 'loading',
  trailers: {},
};

export const trailersSlice = createSlice({
  name: 'trailers',
  initialState,
  reducers: {
    loadedFromServer(state, action: PayloadAction<readonly Trailer[]>) {
      state.status = 'loaded';
      state.trailers = keyBy(action.payload, (trailer) => trailer.guid);
    },

    loadingCatastrophicallyFailed(state) {
      state.status = 'catastrophicallyFailed';
    },

    trailerCreated(state, action: PayloadAction<Trailer>) {
      state.trailers[action.payload.guid] = action.payload;
    },

    trailerArchivedStatusSet(state, action: PayloadAction<{ guid: string; archived: boolean }>) {
      const { guid, archived } = action.payload;
      state.trailers[guid].archived = archived;
    },
  },
});
